import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zixunfenlei",
  "use": "icon-zixunfenlei-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zixunfenlei\"><path d=\"M282.112 128H96.192a32 32 0 0 0-32 32v696.128a32 32 0 0 0 32 32h185.92a32 32 0 0 0 32-32V160.192a32 32 0 0 0-32-32.192z m-32 696.128h-121.6V192.384h121.6z m708.352-30.912l-178.24-589.312a32 32 0 0 0-39.872-21.248l-151.168 45.696V160.128a32 32 0 0 0-32-32H370.88a32 32 0 0 0-32 32v696.128a32 32 0 0 0 32 32H556.8a32 32 0 0 0 32-32V436.16l129.984 428.8a32 32 0 0 0 39.872 21.888l178.24-54.016a32.896 32.896 0 0 0 19.2-15.424 29.76 29.76 0 0 0 2.176-24.192z m-433.6 30.912h-121.6V192.384h121.6z m246.4-8.384L611.712 288.192l116.416-35.392 159.552 527.552z\" p-id=\"8380\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zixunfenlei.svg
// module id = /2Yd
// module chunks = 65